import React from 'react';
import background from '../../../assets/images/landing.jpg';
import { BackgroundImageStyle } from './BackgroundImage.style';

export interface BackgroundImageProps {
    children: React.ReactNode;
}

const BackgroundImage = (props: BackgroundImageProps): JSX.Element => {
    const classes = BackgroundImageStyle(background);

    return <div className={`${classes.root} ${classes.backgroundImage}`}>{props.children}</div>;
};

export default BackgroundImage;
